// extracted by mini-css-extract-plugin
export default {"iconBtn":"VDDvit3YeIvIZWZKtE2E"};